module.exports = __webpack_public_path__ + "img/tabula_nav_logo.31b25e1b.svg";